import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"
interface IDMLiveFeedEventId {
	live_feed_event_id: string | undefined
}
export const DMLiveFeedEventId = atom<IDMLiveFeedEventId | undefined>({
	key: ATOMS_KEYS.DMLIVEFEEDEVENTID,
	default: undefined,
})
